<kendo-dialog-titlebar (close)="fecheModal()" [class.api-titlebar]="dadosApi" closeTitle="Fechar">
  <h4 *ngIf="!dadosApi"> {{titulo}}  </h4>
  <div class="api-cabecalho" *ngIf="dadosApi">
    <span class="api-simbolo" aria-hidden="true"><i class="fa fa-code"></i></span>
    <div>
      <h3>{{titulo}}</h3>
      <p>{{descricao}}</p>
    </div>
  </div>

</kendo-dialog-titlebar>

<div #pnl class="modal-body" *ngIf="!dadosApi">
  <p class="text-muted" *ngIf="descricao">{{descricao}}</p>
  <button class="btn btn-blue btn-sm float-right" (click)="copieJson()">copiar</button>
  <div class="clearfix"> </div>
  <div class="table-responsive" *ngIf="emTabela">
    <table class="table table-sm table-bordered tabela-json">
      <thead><tr><th>Campo</th><th>Valor</th></tr></thead>
      <tbody>
        <tr *ngFor="let item of campos"><td>{{item.campo}}</td><td>{{item.valor}}</td></tr>
      </tbody>
    </table>
  </div>
  <div class="json" *ngIf="!emTabela">
    <app-json-display [data]="payload"></app-json-display>
  </div>
</div>

<div class="api-view" *ngIf="dadosApi">
  <div class="api-corpo">
    <div class="api-resumo">
      <div class="api-resumo-card">
        <span class="api-card-icone roxo" aria-hidden="true"><i class="fa fa-store"></i></span>
        <div><span class="api-legenda">Canal</span><strong [class.api-aiqfome]="parceiroAiqfome">{{canal || 'Não informado'}}</strong></div>
      </div>
      <div class="api-resumo-card" *ngIf="resumo.tipo">
        <span class="api-card-icone" aria-hidden="true"><i class="fa fa-truck"></i></span>
        <div><span class="api-legenda">Tipo</span><strong>{{resumo.tipo}}</strong></div>
      </div>
      <div class="api-resumo-card" *ngIf="resumo.status">
        <span class="api-card-icone" aria-hidden="true"><i class="fa fa-info-circle"></i></span>
        <div><span class="api-legenda">Status do pedido</span><strong>{{resumo.status}}</strong></div>
      </div>
      <div class="api-resumo-card">
        <span class="api-card-icone" aria-hidden="true"><i class="fa fa-file-alt"></i></span>
        <div><span class="api-legenda">Pedido no parceiro</span><strong>{{resumo.pedido || 'Não informado'}}</strong></div>
      </div>
      <div class="api-resumo-card" *ngIf="resumo.loja">
        <span class="api-card-icone roxo" aria-hidden="true"><i class="fa fa-store"></i></span>
        <div><span class="api-legenda">Loja no parceiro</span><strong>{{resumo.loja}}</strong></div>
      </div>
    </div>
    <p class="api-consulta" *ngIf="consultadoEm">
      <i class="fa fa-clock" aria-hidden="true"></i>
      Consultado em {{consultadoEm | date:'dd/MM/yyyy HH:mm:ss'}} · Dados desta consulta, sem atualização automática.
    </p>

    <div class="api-navegacao">
      <nav class="api-abas" aria-label="Seções dos dados da API">
        <button type="button" *ngFor="let aba of abas" [class.ativa]="abaAtiva === aba.id"
                [attr.aria-pressed]="abaAtiva === aba.id" (click)="selecioneAba(aba.id)">
          <i class="fa {{aba.icone}}" aria-hidden="true"></i> {{aba.titulo}}
          <span *ngIf="aba.id !== 'json'">{{contagem(aba.id)}}</span>
        </button>
      </nav>
      <div class="api-acoes">
        <button type="button" (click)="copieJson()"><i class="fa fa-copy" aria-hidden="true"></i> Copiar JSON</button>
        <button type="button" (click)="baixeJson()"><i class="fa fa-download" aria-hidden="true"></i> Baixar JSON</button>
      </div>
    </div>
    <p class="api-copia" *ngIf="mensagemCopiada" role="status">{{mensagemCopiada}}</p>

    <ng-container *ngIf="abaAtiva !== 'json'">
      <div class="api-ferramentas">
        <label class="api-busca">
          <i class="fa fa-search" aria-hidden="true"></i>
          <input type="search" [(ngModel)]="busca" placeholder="Buscar campo ou valor nesta aba..." aria-label="Buscar campo ou valor nesta aba">
        </label>
        <div class="api-filtros" aria-label="Filtrar campos">
          <button type="button" [class.ativo]="filtro === 'todos'" [attr.aria-pressed]="filtro === 'todos'" (click)="filtro = 'todos'">Todos <span>{{quantidades.todos}}</span></button>
          <button type="button" [class.ativo]="filtro === 'preenchidos'" [attr.aria-pressed]="filtro === 'preenchidos'" (click)="filtro = 'preenchidos'">Preenchidos <span>{{quantidades.preenchidos}}</span></button>
          <button type="button" [class.ativo]="filtro === 'vazios'" [attr.aria-pressed]="filtro === 'vazios'" (click)="filtro = 'vazios'">Vazios <span>{{quantidades.vazios}}</span></button>
        </div>
      </div>

      <section class="api-grupo" *ngFor="let grupo of gruposVisiveis">
        <button type="button" class="api-grupo-titulo" (click)="grupo.expandido = !grupo.expandido" [disabled]="filtrando"
                [attr.aria-expanded]="grupo.expandido || filtrando">
          <span><i class="fa fa-box" aria-hidden="true" *ngIf="abaAtiva === 'itens'"></i> {{grupo.titulo}}</span>
          <i class="fa" [class.fa-chevron-up]="grupo.expandido || filtrando" [class.fa-chevron-down]="!grupo.expandido && !filtrando" aria-hidden="true"></i>
        </button>
        <div class="api-tabela" *ngIf="grupo.expandido || filtrando">
          <table>
            <thead><tr><th>Campo</th><th>Valor</th><th>Tipo</th><th>Descrição</th></tr></thead>
            <tbody>
              <tr *ngFor="let campo of linhas(grupo)" [class.api-vazio]="campo.vazio">
                <td class="api-campo" data-label="Campo">
                  <div [style.padding-left.px]="(campo.nivel > 5 ? 5 : campo.nivel) * 12">
                    <button type="button" class="api-expandir" *ngIf="campo.filhos.length"
                            (click)="campo.expandido = !campo.expandido" [disabled]="filtrando"
                            [attr.aria-expanded]="campo.expandido || filtrando" [attr.aria-label]="'Expandir ou recolher ' + campo.campo">
                      <i class="fa" [class.fa-chevron-down]="campo.expandido || filtrando" [class.fa-chevron-right]="!campo.expandido && !filtrando" aria-hidden="true"></i>
                    </button>
                    <code>{{campo.campo}}</code>
                  </div>
                </td>
                <td class="api-valor" data-label="Valor">{{campo.valor}}</td>
                <td data-label="Tipo"><span class="api-tipo" [class.numero]="campo.tipo === 'number'" [class.estrutura]="campo.tipo === 'object' || campo.tipo === 'array'">{{campo.tipo}}</span></td>
                <td class="api-observacao" data-label="Descrição">{{campo.observacao || '—'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <p class="api-sem-resultados" *ngIf="!gruposVisiveis.length">Nenhum campo encontrado nesta aba.</p>
    </ng-container>

    <div class="api-json" *ngIf="abaAtiva === 'json'">
      <p>Resposta completa do parceiro nesta consulta, incluindo os campos sem descrição.</p>
      <textarea readonly [value]="jsonCompleto" aria-label="JSON completo retornado pelo parceiro" spellcheck="false"></textarea>
    </div>
  </div>
  <footer class="api-rodape">
    <p><i class="fa fa-info-circle" aria-hidden="true"></i> Os valores originais são preservados. Campos ausentes não são adicionados; zero e false são valores preenchidos. Credenciais são ocultadas por segurança.</p>
    <button type="button" (click)="fecheModal()">Fechar</button>
  </footer>
</div>
